<template>
  <div class="good-info-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="base-info group">
          <div class="basic">
            <!-- <span>*</span> -->
            <span v-if="type === 'add'">+ 新建品牌</span>
            <span v-else>编辑品牌</span>
          </div>
          <el-form
            ref="form"
            :rules="rules"
            :model="info"
            class="good-form base-info-form"
            label-width="100px"
          >
            <el-form-item label="品牌名称" prop="brandName" class="form-item">
              <el-input
                placeholder="请输入品牌名称"
                v-model="info.brandName"
                class="good-input"
              ></el-input>
            </el-form-item>
            <el-form-item label="Logo" class="form-item" prop="logo">
              <p class="tips" style="margin-bottom: 8px">
                建议尺寸：600*600，图片类型jpg、png
              </p>
              <div class="img-box">
                <imgUpLoader
                  :max-pic-num="1"
                  @getPics="getMasterImgList"
                  :index="0"
                  text="Logo"
                  :imgUrl="info.logo"
                />
              </div>
            </el-form-item>
            <el-form-item label="主营品类" prop="profit" class="form-item">
              <div class="category">
                <div class="item" v-for="(item, index) in categorySelected" :key="item.id">
                  {{ item.labelName }}
                  <div class="iconfont icon-shanchu" @click="deleteCategory(index)"></div>
                </div>
              </div>
              <div class="add-category" @click="handleCategoryModal">+ 添加品类</div>
            </el-form-item>
            <el-form-item label="排序" prop="sort" class="form-item">
              <el-input
                placeholder="请输入"
                v-model="info.sort"
                class="good-input"
                style="width: 240px"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="品牌简介" prop="brandIntroduce" class="form-item">
              <el-input
                type="textarea"
                :rows="5"
                style="width: 600px"
                placeholder="请输入品牌简介"
                v-model="info.brandIntroduce">
              </el-input>
            </el-form-item>
          </el-form>
        </div>

        <div class="btn-box">
          <button class="cancel-btn" @click="handleCancel">取消</button>
          <button class="confirm-btn" @click="handleConfirm">保存</button>
        </div>
      </div>
    </div>
    <el-dialog title="添加/关联品类" width="480px" :visible.sync="categoryVisible">
      <div :key="timeStamp">
        <el-table
          :data="category"
          class="order-table table no-border-table"
          ref="categoryTable"
          height="500px"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            prop="labelName"
            align="center"
            label="选项名称"
          ></el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn cancel-btn" @click="categoryVisible = false"
          >取 消</el-button
        >
        <el-button class="btn confirm-btn" @click="addCategory">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import imgUpLoader from '../../components/goods/imgUpLoader';
export default {
  components: { imgUpLoader },
  name: 'goods-lock',
  data() {
    return {
      loading: 0,
      title: {
        // 页面标题
        firstTitile: '产品管理',
        secondTitle: '品牌详情'
      },
      type: '',
      rules: {
        brandName: [
          {
            required: true,
            message: '请输入商品名称',
            trigger: 'blur'
          }
        ],
        logo: [
          {
            required: true,
            message: '请上传主图图片',
            trigger: 'change'
          }
        ],
      },
      info: {
        brandName: '',
        brandIntroduce: '',
        logo: '',
        hotBrand: 2,
        sort: null
      },
      categoryVisible: false,
      category: [],
      multipleSelection: [],
      categorySelected: [],
      timeStamp: +new Date(),
      selectMap: {}
    };
  },
  computed: {},
  async mounted() {
    let query = this.$route.query;
    this.type = query.type;

    await this.getLabelByName('category');

    if (query && query.id) {
      this.id = +query.id;
      this.getBrandDetail(query.id);
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 获取商品信息
    getBrandDetail(id) {
      this.loading++;
      this.httpGet(this.$root.getBrandInfo, { id }).then(
        (res) => {
          this.loading--;
          let info = { ...this.info };
          for (let key in info) {
            info[key] = res[key];
          }
          this.info = { ...info };
          res.categoryArr.forEach(item => {
            this.selectMap[item] = true;
          });
          this.category.forEach(item => {
            if(this.selectMap[item.id]){
              this.categorySelected.push(item);
            }
          })
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getLabelByName(dataName){
      this.loading++;
      return this.httpGet(this.$root.getLabelByName, {
        dataName
      }).then(
        (res) => {
          this.loading--;
          this[dataName] = res.list;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    handleCategoryModal(){
      this.multipleSelection = this.categorySelected;
      this.timeStamp = +new Date();
      this.categoryVisible = true;
      this.$nextTick(() => {
        this.$refs.categoryTable.clearSelection();
        this.multipleSelection.forEach(item => {
          this.$refs.categoryTable.toggleRowSelection(item, true);
        });
      })
    },
    addCategory(){
      // console.log(this.multipleSelection);
      this.categorySelected = this.multipleSelection;
      this.categoryVisible = false;
    },
    deleteCategory(index){
      this.categorySelected.splice(index, 1);
    },
    // 取消
    handleCancel() {
      this.$router.push({ name: 'brandManage' });
    },

    getMasterImgList(index, val) {
      if (val === '') {
        // slideshow.splice(index, 1);
        this.info.logo = null;
      } else {
        this.info.logo = val;
      }
      this.$refs.form.clearValidate(['logo']);
    },

    // 添加商品
    handleConfirm() {
      // 请求数据
      let inputData = {
        ...this.info,
        sort: +this.info.sort,
        categoryArr: this.categorySelected.map(item => item.id)
      };
      // 是否为编辑品牌
      let method = 'httpPost';
      if (this.id) {
        method = 'httpPut';
        inputData.id = this.id;
      }
      this.loading++;
      this[method](
        this.id ? this.$root.updateBrand : this.$root.addBrand, // 添加品牌 or 创建品牌
        inputData
      ).then(
        (res) => {
          this.$message({
            message: this.id ? '品牌修改成功' : '品牌创建成功',
            type: 'success'
          });
          this.loading--;
          this.$router.push({
            name: 'brandManage'
          });
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.good-info-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 0 20px 20px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      // background: white;
      box-sizing: border-box;
      padding: 0 20px 24px;
      border-radius: 2px;

      .group {
        background: white;
        padding: 10px 0;
        margin-bottom: 10px;
        .basic {
          height: 48px;
          line-height: 48px;
          font-size: 20px;
          text-indent: 20px;
          // margin-top: 20px;
          color: gray3;
          flex-x(flex-start);

          span {
            // color: red;
            color: gray6;
            margin-right: 3px;
          }
        }
      }

      .base-info {
        // margin-bottom: 10px;
        background: white;

        .good-form {
          padding: 20px 0 30px;

          .img-box {
            flex-x(flex-start);
          }
        }

        .category{
          width: 600px;
          min-height: 120px;
          border-radius: 5px;
          border: 1px solid #E8E8E8;
          padding: 6px 10px;
          box-sizing: border-box;
          flex-x(flex-start, flex-start);
          flex-wrap: wrap;
          .item{
            height: 24px;
            min-width: 60px;
            padding:0 12px;
            border-radius: 2px;
            background: #EBEBEB;
            word(12px, #333);
            flex-x(center);
            margin-right: 8px;
            margin-bottom: 8px;
            position: relative;
            div{
              line-height: 16px;
              position: absolute;
              right: -6px;
              top: -6px;
              cursor: pointer;
            }
          }
        }

        .add-category{
          width: 80px;
          cursor: pointer;
          color: #5283FF;
          flex-x(flex-start);
          flex-shrink: 0;
        }

        .base-info-form {
          margin-left: 90px;
        }

        .good-input {
          width: 620px;
        }

        .tip {
          font-size: 14px;
          color: gray6;
          margin-left: 16px;
        }
      }
    }
  }

  .btn-box {
    background: white;
    width: 100%;
    flex-x(center);
    height: 100px !important;
    flex-shrink: 0;
    // padding-bottom: 48px;

    .cancel-btn {
      width: 96px;
      height: 40px;
      cancel-btn();
      // border-radius: 23px;
    }

    .confirm-btn {
      width: 96px;
      height: 40px;
      margin-left: 20px;
      confirm-btn();
    }
  }
}
</style>
